// extracted by mini-css-extract-plugin
export default {"dropdownUnfolding":"Dropdown_dropdownUnfolding__8BJE-"};